require('./bootstrap')
window.Vapor = require('laravel-vapor');

import Vue from 'vue'
import {extend, localize, ValidationObserver, ValidationProvider} from 'vee-validate';
import en from "vee-validate/dist/locale/en.json";
import * as rules from "vee-validate/dist/rules";
import VueTelInput from 'vue-tel-input'
import 'vue-tel-input/dist/vue-tel-input.css'
import Multiselect from 'vue-multiselect'
import Register from './Components/Register.vue'
import Login from './Components/Login.vue'
import AccountManagementLogin from './Components/AccountManagementLogin.vue'
import FindWorkspace from './Components/FindWorkspace.vue'
import CreatingAccount from './Components/CreatingAccount.vue'
import PhoneNumber from './Components/inputs/PhoneNumber.vue'
import {validateSubdomain} from './helpers/subdomain'
import Swal from 'sweetalert2';
window.Swal = Swal;

// Install VeeValidate rules and localization
Object.keys(rules).forEach(rule => {
	extend(rule, rules[rule]);
});

localize("en", en);

// Validates a subdomain against the same format rules as App\Rules\SubdomainFormatRule.
// The reserved word check is deliberately server side only.
extend('subdomain_format', {
	validate: value => validateSubdomain(value)
})

Vue.use(VueTelInput, {
	mode: 'international'
})

Vue.mixin({
    methods: {
        asset: window.Vapor.asset
    },
});

Vue.component("ValidationObserver", ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);

Vue.component('multiselect', Multiselect)

// Blade renders the surrounding page. Mount the precompiled components as islands
// so the browser does not need Vue's vulnerable HTML template parser.
const components = {
    register: Register,
    login: Login,
    'account-management-login': AccountManagementLogin,
    'find-workspace': FindWorkspace,
    'creating-account': CreatingAccount,
    'phone-number': PhoneNumber,
}

document.querySelectorAll('#app register, #app login, #app account-management-login, #app find-workspace, #app creating-account, #app phone-number').forEach(element => {
    const component = components[element.localName]
    const props = {}
    const attrs = {}

    for (const attribute of element.attributes) {
        if (attribute.name === ':partner') {
            props.partner = JSON.parse(attribute.value)
        } else if (['domain', 'value'].includes(attribute.name)) {
            props[attribute.name] = attribute.value
        } else {
            attrs[attribute.name] = attribute.value
        }
    }

    new Vue({
        render: createElement => createElement(component, { props, attrs }),
    }).$mount(element)
})
